import React, { useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import axios from "axios";
import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card } from "@/components/ui/card";
import { Loader2, KeyRound } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ResetPasswordPage() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 6) { toast.error("La password deve avere almeno 6 caratteri"); return; }
    if (password !== confirm) { toast.error("Le password non coincidono"); return; }
    setLoading(true);
    try {
      await axios.post(`${API}/auth/reset-password`, { token, password });
      toast.success("Password aggiornata! Ora puoi accedere.");
      navigate("/login", { replace: true });
    } catch (err) {
      toast.error(err.response?.data?.detail || "Errore nel reset della password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#3b444f] px-4">
      <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} className="w-full max-w-md">
        <Card className="p-8 border-slate-200">
          <div className="flex items-center gap-3 mb-6">
            <span className="inline-flex h-11 w-11 items-center justify-center rounded-xl bg-teal-600 text-white"><KeyRound className="h-5 w-5" /></span>
            <div>
              <h1 className="font-heading text-xl font-semibold text-slate-900">Reimposta password</h1>
              <p className="text-sm text-slate-500">Scegli una nuova password per il tuo account.</p>
            </div>
          </div>
          {!token ? (
            <p className="text-sm text-red-600">Link non valido. Richiedi un nuovo recupero password dalla pagina di accesso.</p>
          ) : (
            <form onSubmit={submit} className="space-y-4">
              <div className="space-y-2">
                <Label htmlFor="pwd">Nuova password</Label>
                <Input id="pwd" data-testid="reset-password-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required placeholder="Almeno 6 caratteri" />
              </div>
              <div className="space-y-2">
                <Label htmlFor="cpwd">Conferma password</Label>
                <Input id="cpwd" data-testid="reset-password-confirm" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required />
              </div>
              <Button type="submit" data-testid="reset-password-submit" disabled={loading} className="w-full bg-teal-600 hover:bg-teal-700">
                {loading ? <Loader2 className="h-4 w-4 mr-1.5 animate-spin" /> : null} Aggiorna password
              </Button>
            </form>
          )}
          <p className="mt-4 text-center text-sm"><Link to="/login" className="text-teal-600 hover:text-teal-700 font-medium">Torna all'accesso</Link></p>
        </Card>
      </motion.div>
    </div>
  );
}
